import React from 'react'
import { NavLink } from 'react-router-dom'

import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined'
import OutboxOutlinedIcon from '@mui/icons-material/OutboxOutlined'

import emptyDoc from './../../img/empty_documents.svg'
import Empty from './../_ui/empty'
import css from './disciplineFiles.module.scss'

const DisciplineFiles = (props: any) => {
    return (
        <section className={css.main}>
            <section className={css.mainContainer}>
                <header className={css.header}>
                    <div>
                        <h4>Список файлов</h4>
                    </div>

                    <div className='myButtonIconTextPrimary' onClick={() => window.history.back()}>
                        <OutboxOutlinedIcon sx={{ fontSize: 26 }} />
                        <span>К ДИСЦИПЛИНАМ</span>
                    </div>
                </header>

                <section className={css.container}>
                    {!props.filesList.length
                        ? <Empty image={emptyDoc} description="" />
                        : props.filesList.map((item: any) => {
                            return (
                                <NavLink to={item.file_path} key={item.file_id} target='_blank' rel='noreferrer' className={css.tRow}>
                                    <PictureAsPdfOutlinedIcon />
                                    <div>{item.file_name}</div>
                                </NavLink>
                            )
                        })
                    }
                </section>
            </section>
        </section>
    )
}

export default DisciplineFiles